export default class SignupBasicAccountCtrl {

    // @ngInject
    constructor($location, signupDataStore,
            config, vcRecaptchaService,
            responseHandler, authService,
            countryData,
            userTypes, usageTypes, $window) {
        this.$location = $location;
        this.signupDataStore = signupDataStore;
        this.responseHandler = responseHandler;
        this.authService = authService;
        this.userTypes = userTypes;
        this.usageTypes = usageTypes;
        this.vcRecaptchaService = vcRecaptchaService;

        // $window.ga('send', 'pageview', this.$location.url());
        $window.gtag('config', 'G-Z5WQRDSH6E');

        responseHandler(countryData.query().$promise, 'fetching countries')
            .then((countries) => this.countries = countries);

        this.registration = {
            user_type: userTypes.free.key,
            first_name: undefined,
            last_name: undefined,
            email: undefined,
            password1: undefined,
            password2: undefined,
            show_pwd_hint: false,
            country: undefined,
            usage_type: undefined,
            receive_news: true,
            agree_toc: false,
            bdn_member: false
        };
        this.showPassword = false;
        this.passwordFieldType = 'password';
        this.registration.bdn_member = $location.search().bdn;
        this.registration.next_url = $location.search().next ? $location.search().next.replace('%2F%23', '%23') : config.loginRedirectUrl;
        this.registration.login_url_next_param = $location.search().next ? encodeURIComponent(decodeURIComponent($location.search().next).replace('/#', '#')) : config.loginRedirectUrl;
        this.registration.social_next_param = this.registration.login_url_next_param !== '' ? '?next=' + this.registration.login_url_next_param : '';
        this.next = '/signup/free/confirmation';
        this.recaptcha_key = config.recaptchaPubKey;

        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?render=6Lfwn_wgAAAAAEFmisC38nkGHJIB0kpkQTxEwjFF';
        script.id = 'recaptchaLibrary';
        document.body.appendChild(script);


        if (window.location.pathname.endsWith('signup/free') && window.innerWidth > 1243) {
            document.querySelector('ng-view.main').style.width='100%';
            document.querySelector('ng-view.main').style.maxWidth='100%';
            document.querySelector('ng-view.main').style.transform='translateY(-5%)';
        }
    }

    submit() {
        const data = this.registration;
        const self = this;
        window.grecaptcha.ready(() => {
            window.grecaptcha.execute('6Lfwn_wgAAAAAEFmisC38nkGHJIB0kpkQTxEwjFF').then((token) => {
                data.recaptcha_response = token;
                data.password2 = data.password1;
                data.country = 'IN';
                data.usage_type = 'starter_signedup';
                let promise = self.authService.register(self.registration);
                self.responseHandler(promise, 'submitting the form')
                    .then((account) => {
                        self.signupDataStore.account = angular.extend(account, {
                            country: self.registration.country // Not returned by backend
                        });
                        self.$location.path(self.next);
                    }).finally(() => {
                        window.grecaptcha.reset('6Lfwn_wgAAAAAEFmisC38nkGHJIB0kpkQTxEwjFF');
                    });
            });
        });
    }

    togglePasswordShow() {
        this.showPassword = !this.showPassword;
        this.passwordFieldType = this.showPassword ? 'text' : 'password';
    }

    recaptchaExpiration() {
        // eslint-disable-next-line no-undef
        window.grecaptcha.reset('6Lfwn_wgAAAAAEFmisC38nkGHJIB0kpkQTxEwjFF');
        this.response = null;
    }

    setRecaptchaResponse(response) {
        this.registration.recaptcha_response = response;
    }

}



// WEBPACK FOOTER //
// ./signup-basic/account/account-ctrl.js